import axios from "axios";
import Config from "../../utils/Config";

const NEWS_CHANGED_EVENT = "mogu:feature-news-changed";

const authConfig = (accessToken) => ({
  headers: {
    Authorization: accessToken,
    GroupId: localStorage.getItem("groupId") || "",
    CompanyId: localStorage.getItem("companyId") || "",
  },
});

export const notifyFeatureNewsChanged = () => {
  window.dispatchEvent(new CustomEvent(NEWS_CHANGED_EVENT));
};

export const subscribeFeatureNewsChanged = (handler) => {
  window.addEventListener(NEWS_CHANGED_EVENT, handler);
  return () => window.removeEventListener(NEWS_CHANGED_EVENT, handler);
};

export const listPublishedFeatureNews = async (accessToken) => {
  const res = await axios.get(
    `${Config.BACKEND_URL}/api/feature-news`,
    authConfig(accessToken)
  );
  return Array.isArray(res.data?.data) ? res.data.data : [];
};

export const listAdminFeatureNews = async (accessToken) => {
  const res = await axios.get(
    `${Config.BACKEND_URL}/api/feature-news/admin`,
    authConfig(accessToken)
  );
  return Array.isArray(res.data?.data) ? res.data.data : [];
};

export const getFeatureNews = async (accessToken, id) => {
  const res = await axios.get(
    `${Config.BACKEND_URL}/api/feature-news/${id}`,
    authConfig(accessToken)
  );
  return res.data?.data;
};

export const createFeatureNews = async (accessToken, payload) => {
  const res = await axios.post(
    `${Config.BACKEND_URL}/api/feature-news`,
    payload,
    authConfig(accessToken)
  );
  notifyFeatureNewsChanged();
  return res.data?.data;
};

export const updateFeatureNews = async (accessToken, id, payload) => {
  const res = await axios.put(
    `${Config.BACKEND_URL}/api/feature-news/${id}`,
    payload,
    authConfig(accessToken)
  );
  notifyFeatureNewsChanged();
  return res.data?.data;
};

export const deleteFeatureNews = async (accessToken, id) => {
  const res = await axios.delete(
    `${Config.BACKEND_URL}/api/feature-news/${id}`,
    authConfig(accessToken)
  );
  notifyFeatureNewsChanged();
  return res.data?.data;
};
